/* eslint-disable @typescript-eslint/no-explicit-any */
import { iArtist, iArtistQuery } from "../../../definitions/Artists"
import { iArtPiece, iArtPieceQuery } from "../../../definitions/ArtPieces"
import { iExhibition, iExhibitionQuery } from "../../../definitions/Exhibition"
import { iSpace, iSpaceQuery } from "../../../definitions/Space"
import { useData } from "../../../hooks/useData"

interface iProps {
  dataType: string
  query: any
}

export function useFeaturedData({ dataType, query = {} }: iProps): any {
  switch (dataType) {
    case "ArtPieces":
      return useData<iArtPieceQuery, iArtPiece>({
        link: "/v1/art-pieces",
        defaultQuery:
          query && query.tagId ? { shrStyle: [query.tagId] } : query,
        shouldPingForData: false,
      })
    case "Exhibitions":
      return useData<iExhibitionQuery, iExhibition>({
        link: "/v2/exhibitions",
        defaultQuery: query,
        shouldPingForData: false,
      })
    case "Spaces":
      return useData<iSpaceQuery, iSpace>({
        link: "/v2/spaces",
        defaultQuery: query,
        shouldPingForData: false,
      })
    case "Artists":
      return useData<iArtistQuery, iArtist>({
        link: "/v1/artists",
        defaultQuery:
          query && query.tagId ? { category: [query.tagId] } : query,
        shouldPingForData: false,
      })
    default:
      return {}
  }
}
